import * as types from '../mutation-types'

const state = {
    // navigator.onLine
    online: null,

    // server fetch HEAD
    serverOnline: null
}

const getters = {
    online: state => state.online,
    serverOnline: state => state.serverOnline
}

const actions = {
    serverOnline ({ commit }) {
        // maks server HEAD request... commit result...
        commit(types.NM_SERVER_ONLINE)
    }
}

const mutations = {
    [types.NM_ONLINE](state) {
        state.online = true
    },
    [types.NM_OFFLINE](state) {
        state.online = false
    },

    [types.NM_SERVER_ONLINE](state) {
        state.serverOnline = true
    },
    [types.NM_SERVER_OFFLINE](state) {
        state.serverOnline = false
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}